module.exports = __webpack_public_path__ + "video/SAF-1500-1_Ares_AIChatbots_2025.38fa7421.vtt";